<template>
  <div class="tw-mt-2">
    <WdsText v-if="data.title && data.title !== sectionTitle" :text="data.title" sm class="tw-font-medium" />
    <ComplianceDataFieldRow
      v-for="(field, idx) in data.fields"
      :key="idx"
      :label="field.label"
      :value="field.value ?? null"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import ComplianceDataFieldRow from './ComplianceDataFieldRow.vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const ComplianceDataGroupFragment = graphql(`
  fragment ComplianceDataGroup on ComplianceDataGroup {
    title
    fields {
      label
      value
    }
  }
`)

const props = defineProps<{ entry: FragmentType<typeof ComplianceDataGroupFragment>; sectionTitle?: string }>()
const data = computed(() => useFragment(ComplianceDataGroupFragment, props.entry))
</script>
